import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

// Pro Solid Icons
import {
  faAlarmClock,
  faAlbumCollection,
  faArrowUpArrowDown,
  faBarsSort,
  faBell,
  faBullhorn,
  faCamera,
  faCameraWeb,
  faCheckCircle,
  faChevronRight,
  faCircleCheck,
  faCircleDollar,
  faExclamationTriangle,
  faFilm,
  faGlobe,
  faHeartCircleCheck,
  faHeartCirclePlus,
  faHome,
  faIdBadge,
  faLock,
  faMagnifyingGlass,
  faMedal,
  faRightFromBracket,
  faSearch,
  faShapes,
  faSpinner,
  faSpinnerThird,
  faStar,
  faSuitcase,
  faThumbsDown,
  faThumbsUp,
  faTrophy,
  faUser,
  faVenusMars,
  faVideo,
  faWifi,
  faXmark,
  faXmarkOctagon,
} from "@fortawesome/pro-solid-svg-icons"

// Pro Regular Icons
import {
  faAlbumCollection as farAlbumCollection,
  faBell as farBell,
  faBellSlash,
  faCamera as farCamera,
  faCameraWeb as farCameraWeb,
  faChevronLeft,
  faChevronRight as farChevronRight,
  faCircleDollar as farCircleDollar,
  faCircleQuestion,
  faComments,
  faDownload,
  faFilm as farFilm,
  faGlobe as farGlobe,
  faHeartCirclePlus as farHeartCirclePlus,
  faHouseBlank,
  faLock as farLock,
  faMagnifyingGlass as farMagnifyingGlass,
  faMedal as farMedal,
  faOctagonExclamation,
  faShapes as farShapes,
  faSignalStream,
  faStar as farStar,
  faSuitcase as farSuitcase,
  faThumbsDown as farThumbsDown,
  faThumbsUp as farThumbsUp,
  faTrophy as farTrophy,
  faTrophyStar,
  faVenusMars as farVenusMars,
  faVideo as farVideo,
  faXmark as farXmark,
} from "@fortawesome/pro-regular-svg-icons"

// Pro Light Icons
import { faArrowUpArrowDown as falArrowUpArrowDown } from "@fortawesome/pro-light-svg-icons"

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

// Add only the specific icons that are used in the app
library.add(
  // Pro Solid Icons
  faAlarmClock,
  faAlbumCollection,
  faArrowUpArrowDown,
  faBarsSort,
  faBell,
  faBullhorn,
  faCamera,
  faCameraWeb,
  faCheckCircle,
  faChevronRight,
  faCircleCheck,
  faCircleDollar,
  faExclamationTriangle,
  faFilm,
  faGlobe,
  faHeartCircleCheck,
  faHeartCirclePlus,
  faHome,
  faIdBadge,
  faLock,
  faMagnifyingGlass,
  faMedal,
  faRightFromBracket,
  faSearch,
  faShapes,
  faSpinner,
  faSpinnerThird,
  faStar,
  faSuitcase,
  faThumbsDown,
  faThumbsUp,
  faTrophy,
  faUser,
  faVenusMars,
  faVideo,
  faWifi,
  faXmark,
  faXmarkOctagon,

  // Pro Regular Icons
  farAlbumCollection,
  farBell,
  faBellSlash,
  farCamera,
  farCameraWeb,
  faChevronLeft,
  farChevronRight,
  farCircleDollar,
  faCircleQuestion,
  faComments,
  faDownload,
  farFilm,
  farGlobe,
  farHeartCirclePlus,
  faHouseBlank,
  farLock,
  farMagnifyingGlass,
  farMedal,
  faOctagonExclamation,
  farShapes,
  faSignalStream,
  farStar,
  farSuitcase,
  farThumbsDown,
  farThumbsUp,
  farTrophy,
  faTrophyStar,
  farVenusMars,
  farVideo,
  farXmark,

  // Pro Light Icons
  falArrowUpArrowDown,
)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("font-awesome-icon", FontAwesomeIcon, {})
})
